import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  staffTotal: 0,
  staffList: [],
  staffLoading: true,
  authorityTotal: 0,
  authorityList: [],
  authorityLoading: true
};

const slice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    setStaffLoading(state, { payload }) {
      state.staffLoading = payload;
      state.authorityLoading = payload;
    },
    setStaffTable(state, { payload }) {
      state.staffList = payload?.rows;
      state.staffTotal = payload?.total;
      state.staffLoading = false;
    },
    setauthorityTable(state, { payload }) {
      state.authorityList = payload?.rows;
      state.authorityTotal = payload?.total;
      state.authorityLoading = false;
    }
  }
});

export default slice.reducer;

export const { setStaffTable, setStaffLoading, setauthorityTable } = slice.actions;
